function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Arrow-down-1",
  className: "cls-1",
  d: "M1.469,3a1.516,1.516,0,0,1,1.039.4l4.5,4.247L11.5,3.405a1.531,1.531,0,0,1,2.075,0,1.332,1.332,0,0,1,0,1.961L8.04,10.593a1.523,1.523,0,0,1-2.073,0L.434,5.366a1.33,1.33,0,0,1,0-1.961A1.51,1.51,0,0,1,1.469,3"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/arrow-down.3b19fe1a.svg";
export { SvgComponent as ReactComponent };